import { createContext, useContext } from "react";
import type { User } from "@/types/auth.types";

export type AuthContextType = {
  user: User | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  getMe: () => Promise<void>;
  isUninitialized: boolean;
  // 已登入但非教師／編輯身分（無使用權限）
  isForbidden: boolean;
  // 無權限時 API 回傳的提示訊息
  forbiddenMessage: string;
};

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within a AuthProvider");
  }
  return context;
};
